import React from 'react';
import { Heart, Award, Gem, Shield, Sparkles, Clock } from 'lucide-react';
import { benefits } from '../data/mock';

const iconMap = {
  Heart: Heart,
  Award: Award,
  Gem: Gem,
  Shield: Shield,
  Sparkles: Sparkles,
  Clock: Clock,
};

export const BenefitsSection = () => {
  return (
    <section className="relative overflow-hidden bg-neutral-900 py-24">
      {/* Background decoration */}
      <div className="absolute inset-0">
        <div className="absolute -left-40 top-0 h-96 w-96 rounded-full bg-[#d4af37]/5 blur-3xl" />
        <div className="absolute -right-40 bottom-0 h-96 w-96 rounded-full bg-[#d4af37]/5 blur-3xl" />
      </div>

      {/* Gold accent lines */}
      <div className="absolute left-0 top-1/3 h-px w-32 bg-gradient-to-r from-transparent to-[#d4af37]/30" />
      <div className="absolute right-0 bottom-1/3 h-px w-32 bg-gradient-to-l from-transparent to-[#d4af37]/30" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center">
          <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-[#d4af37]/10 px-4 py-1.5 text-sm font-medium text-[#d4af37] border border-[#d4af37]/30">
            <Sparkles className="h-4 w-4" />
            ¿Por qué elegirnos?
          </div>
          <h2 className="font-serif text-3xl font-bold text-white sm:text-4xl lg:text-5xl">
            Nos distingue la excelencia
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-neutral-400">
            Cada detalle está pensado para brindarte una experiencia única de belleza y bienestar
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {benefits.map((benefit, index) => {
            const IconComponent = iconMap[benefit.icon];
            
            return (
              <div
                key={index}
                className="group relative overflow-hidden rounded-2xl bg-neutral-800/50 p-8 backdrop-blur-sm transition-all duration-300 hover:bg-neutral-800 border border-neutral-700/50 hover:border-[#d4af37]/30"
              >
                {/* Decorative corner */}
                <div className="absolute -right-8 -top-8 h-24 w-24 rounded-full bg-[#d4af37]/5 transition-transform duration-300 group-hover:scale-150" />
                
                <div className="relative">
                  {/* Icon */}
                  <div className="mb-6 inline-flex h-14 w-14 items-center justify-center rounded-xl bg-[#d4af37]/10 border border-[#d4af37]/20">
                    {IconComponent && (
                      <IconComponent className="h-7 w-7 text-[#d4af37]" />
                    )}
                  </div>

                  {/* Content */}
                  <h3 className="text-xl font-semibold text-white">
                    {benefit.title}
                  </h3>
                  <p className="mt-3 text-neutral-400">
                    {benefit.description}
                  </p>
                </div>

                {/* Bottom accent line */}
                <div className="absolute bottom-0 left-0 h-1 w-0 bg-gradient-to-r from-[#d4af37] to-[#b8860b] transition-all duration-300 group-hover:w-full" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
